import styles from "./ShipFromStore.module.scss";

import { ShipFromStoreDrawer } from "./ShipFromStoreDrawer";
import { DeliveryOutlined as Delivery } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/DeliveryOutlined";
import { ArrowRightOutlined as ArrowRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ArrowRightOutlined";
import { ListItem } from "@/components/__shared__/ListItem/ListItem";
import { useRef, useState } from "react";
import { dispatchAnalyticsEvent } from "@/utils";

interface Props {
  price: string;
}

export function ShipFromStoreUI({ price }: Props) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const isStandardDelivery = Number(price) < 50;
  const isDrawerInteractionDispatched = useRef(false);

  function dispatchOverLayOpenedEvent() {
    dispatchAnalyticsEvent("shipfromstore.overlay", {}, {});
  }

  function handleClick(): void {
    if (!isDrawerInteractionDispatched.current) {
      dispatchOverLayOpenedEvent();
      isDrawerInteractionDispatched.current = true;
    }
    setIsDrawerOpen(true);
  }

  return (
    <>
      <ListItem
        label={"Delivery from store"}
        description={
          <ul className={styles.infoList}>
            <li>
              {isStandardDelivery
                ? `This item is only available for delivery from one of our stores. Standard delivery £4.50.`
                : `This item is only available for delivery from one of our stores. Free Standard Delivery.`}
            </li>
            <li>Special offers may not be available</li>
          </ul>
        }
        leadingIcon={<Delivery size="medium" />}
        trailingIcon={<ArrowRight size="medium" />}
        showBottomBorder={true}
        showTopBorder={true}
        onClick={handleClick}
        className={styles.bottomMargin}
      />
      <ShipFromStoreDrawer
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
        isStandardDelivery={isStandardDelivery}
      />
    </>
  );
}
